import $ from 'jquery';
import autocomplete from 'jquery-ui/ui/widgets/autocomplete.js';
import contentTemplate from 'properties/style/font.ejs';
import BasePropertyView from 'BasePropertyView.js';
import util from 'util/Util.js';
import themeService from 'ThemeService';
import eventBus from "../../../service/EventBus";
import constants from "../../../constants/Constants";
import fontService from 'FontService';
import listService from 'ListService';

class StyleFontView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        // Note: , #fontSize' is handled on the autocompleteselect function
        this.events = {
            'change #fontFamily, #customFontFamily': 'updateAttributes'
        };

        let currentFont = this.resolveThemeFontProperty('fontFamily');
        fontService.initCustomFont(this.model, currentFont);

        return this;
    }

    updateAttributes(ev, columnModel = undefined, name = undefined, value = undefined) {
        let
            propName = ev.currentTarget.name || name,
            propVal = ev.currentTarget.name ? ev.currentTarget.value : value,
            oldValue = this.model.get(propName);

        const webFont = fontService.webFonts.find(font => font.name === propVal);

        if (webFont) {
            fontService.loadWebFontResource(webFont);
        }

        if(propName === "customFontFamily" || propName === "fontFamily"){
            propVal = fontService.updateCustomFont(this.model, propVal);
            this.model.set('fontFamily', propVal);
        }
        
        super.updateAttributes(ev, columnModel, name, value);

        if ( this.isThemeProperty(oldValue) ){
            themeService.deattachTheme(this);
        }
    }

    render() {
        super.render();

        this.$el.html(this.template(this.model.toJSON()));

        const fonts = fontService.loadFontsDropDown(true);
        $("#fontFamily").append(fonts);
      
        this.prepareComboWidget(this.$el);

        this.updateForm();
        const self = this;

        $("#fontSize", this.$el).combobox({
            value: this.resolveThemeFontProperty('fontSize'),
            change: (e, param) => {
                self.model.set('fontSize', param.value);
            }
        });
        
        this.delegateEvents();

        return this;
    }

    updateForm() {
        //set selected index to model value
        if (this.model.get('fontSize')) {
            $('#fontSize').find('option[value=' + this.resolveThemeFontProperty('fontSize') + ']').attr('selected', true);
        }
        
        if (this.model.get('fontFamily')) {
            let font = this.resolveThemeFontProperty('fontFamily');
            const customFont = fontService.isCustomFont(font);
            font = !customFont ? font : "__custom__";
            $('#fontFamily').find('option[value="' + font + '"]').attr('selected', true);
            
        }
    }

    prepareComboWidget($el) {
        let selfThis = this;

        $.widget("custom.combobox", {
            _create: function () {
                this.wrapper = $("<span>")
                    .addClass("custom-combobox")
                    .insertAfter(this.element);

                this.element.hide();
                this._createAutocomplete(this.options);
                this._createShowAllButton();
            },

            _createAutocomplete: function (options) {
                var selected = this.element.children(":selected");

                this.input = $("<input>", {
                    maxLength: 3
                })
                    .appendTo(this.wrapper)
                    .addClass("custom-combobox-input ui-widget ui-widget-content ui-corner-left")
                    .val(options.value)
                    .autocomplete({
                        classes: {
                            "ui-autocomplete": "custom-autocomplete"
                        },
                        delay: 0,
                        minLength: 0,
                        source: $.proxy(this, "_source"),
                        appendTo: $el,
                        search: options.value
                    });

                this._on(this.input, {
                    input: function (e, param) {
                        var value = e.currentTarget.value.replace(/[^0-9]/g, '');

                        this.input.val(value);
                        this.element.val(value);

                        this.input.autocomplete("search", value);
                    }, //PF-2105 - Forms/Reports - Font size (general)
                    change: function(e, param){
                        const name = e.currentTarget.parentElement.parentElement.children[0].name;
                        let value = e.currentTarget.value.replace(/[^0-9]/g, '');
                        this._trigger("change", null, { value: value });
                        this._trigger("select", e, { item: value });
                        selfThis.updateAttributes(e, null, name, value);
                    },
                    autocompleteselect: function (e, ui) {
                        const name = e.currentTarget.parentElement.parentElement.children[0].name;
                        let value =  ui.item.value;
                        ui.item.option.selected = true;
                        this._trigger("change", null, { value: value });
                        this._trigger("select", e, { item: ui.item.option });
                        selfThis.updateAttributes(e, null, name, value);
                    }
                });
            },

            _createShowAllButton: function () {
                var input = this.input,
                    element = this.element,
                    wasOpen = false;

                $("<a>")
                    .attr("tabIndex", -1)
                    .appendTo(this.wrapper)
                    .button({
                        icons: {
                            primary: "ui-icon-triangle-1-s"
                        },
                        text: false
                    })
                    .removeClass("ui-corner-all")
                    .addClass("custom-combobox-toggle ui-corner-right")
                    .on("mousedown", function () {
                        wasOpen = input.autocomplete("widget").is(":visible");
                    })
                    .on("click", function () {
                        input.trigger("focus");

                        // Close if already visible
                        if (wasOpen) {
                            return;
                        }
                        // Pass empty string as value to search for, displaying all results
                        input.autocomplete("search", "20");
                    });
            },

            _source: function (request, response) {
                response(this.element.children("option").map(function () {
                    var text = $(this).text();
                    return {
                        label: text,
                        value: text,
                        option: this
                    };
                }));
            },

            _destroy: function () {
                this.wrapper.remove();
                this.element.show();
            }
        });
    }
}

export default StyleFontView;
